<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Nota del Presidente</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-Professor.jpg'">
                <section class="section">
                    <h3 class="lcu-hero-h3 lcu-center-text">
                        LEGACY CHRISTIAN UNIVERSITY
                    </h3>
                    <h1 class="lcu-hero-h1 lcu-center-text">
                        Nota del Presidente<br/>y Rector
                    </h1>
                </section>
            </HeroBanner>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="col-grid-2">
                        <div class="lcu-col-center">
                            <img src="/assets/apostle.jpg" alt="Professor y Rector" />
                        </div>
                        <div class="lcu-col-center">
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Dr. Uzziel Jurado, Th.D.
                                </h2>
                            </div>
                            <div class="row">
                                Como Rector de esta institución, oro para que esta
                                formación sea un proceso de revelación, transformación
                                y afirmación del llamado que Dios te entregó.
                            </div>
                            <div class="row">
                                Cada clase, cada lectura, cada proyecto y cada corrección
                                tiene un propósito eterno. Estás aquí porque Dios te trajo,
                                y nuestra misión es ayudarte a desarrollar lo que Él
                                depositó en ti.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <HeroBanner
                :image="'/assets/heroes/LCU-Teaching.jpg'"
                :style="{ 'min-height': '500px' }">
                <section class="section">
                    <div class="row">
                        <button
                            class="lcu-play-btn"
                            type="button"
                            @click.prevent="videoModal = true"
                            aria-label="Play button">
                            <img
                                class="lcu-playImg-center"
                                src="/assets/play-button.svg"
                                alt="Play button image" />
                        </button>
                    </div>
                    <div class="row">
                        <h3 class="lcu-h2 lcu-h2-secondary lcu-center-text">
                            No estás aquí por casualidad
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-hero-h3 lcu-center-text lcu-white-text">
                        Estás aquí porque Dios te trajo, y nuestra misión es
                        ayudarte a desarrollar lo que Él depositó en ti.
                        </h1>
                    </div>
                </section>
            </HeroBanner>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            LEGACY CHRISTIAN UNIVERSITY
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-section-h1 lcu-center-text">
                            ¡Tu futuro ministerial comienza aquí!
                        </h1>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Aplicar'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
    <Modal v-model="videoModal" :close="() => { videoModal = false; }">
        <div class="lcu-modal lcu-modal-wide">
        <video-player
            :options="{
            controls: true,
            sources: [
                {
                src: `${WEB_ASSETS_URL}/public-assets/lcu-welcome-video.mp4`,
                type: 'video/mp4'
                }
            ]
            }" />
        </div>
    </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';
import VideoPlayer from 'ç/video-player/VideoPlayer.vue';
import { WEB_ASSETS_URL } from '@/globals/constants';

export default {
  name: 'note-from-president-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
    VideoPlayer,
  },
  data() {
    return {
      videoModal: false,
      WEB_ASSETS_URL,
    };
  },
};
</script>

<style scoped lang="scss">
.lcu-col-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 400px;

    @media only screen and (max-width: $tablet-max) {
      width: 250px;
    }
    @media only screen and (max-width: $mobile-max) {
      width: 100%
    }
  }
}

.lcu-playImg-center {
  width: 95px;
  height: 95px;
  align-self: center;
  justify-self: center;
}

.lcu-play-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>
